module.exports = __webpack_public_path__ + "static/Kiran_Bettadapur-74166953f81eb39634e774d2b6deb8f1.jpg";